import React, { Dispatch, SetStateAction } from "react";
import { DropDownAreaAndChart } from "../../co-dropdown-panel/drop-down-area-and-chart/DropDownAreaAndChart";
import { TextField } from "@fluentui/react/lib/TextField";
import useImportAmountAreaSelectionField from "./ImportAmountAreaSelectionFieldHook";
import { formatMessage } from "../../../../utils/helpers/LanguageHelper";

export interface SelectionAreaProps {
  isEdit?: boolean;
  area: any;
  sheet: any;
  sheetsAreaChartMap: any;
  selectAreaComboBox: any;
  selectAmountFromExcelCell: any;
  selectFromAreaName: boolean;
  isFileExcelExisting?: boolean;
  isComponentInstance?: boolean;
  isLocked?: boolean;
  objectSource: string;
  isOldValueForAreaToHide?: boolean;
  hasSheetToBeSelected?: boolean;
  isLoadingDataExcel?: boolean;
  setIsOldSheetOrAreaSelected?: Dispatch<SetStateAction<boolean>>;
  setIsSheetChartAndAreaToHide?: Dispatch<SetStateAction<boolean>>;
  isSheetChartAndAreaToHide?: boolean;
}

const ImportAmountAreaSelectionField = (props: SelectionAreaProps) => {
  const {
    selectFromAreaName,
    area,
    sheet,
    sheetsAreaChartMap,
    selectAreaComboBox,
    selectAmountFromExcelCell,
    isFileExcelExisting,
    isComponentInstance,
    isLocked,
    objectSource,
  } = props;

  const { areaValue, selectAmountFromExcel } = useImportAmountAreaSelectionField({
    selectAmountFromExcelCell,
    area,
    selectFromAreaName,
    sheet,
  });

  if (selectFromAreaName) {
    return (
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <DropDownAreaAndChart
          isEdit={props.isEdit}
          name={area}
          sheetsAreaChartMap={sheetsAreaChartMap}
          sheet={sheet}
          selectNameComboBox={selectAreaComboBox}
          type={"area"}
          isFileExcelExisting={isFileExcelExisting}
          isComponentInstance={isComponentInstance}
          isLocked={isLocked}
          objectSource={objectSource}
          isOldValueForAreaToHide={props.isOldValueForAreaToHide}
          hasSheetToBeSelected={props.hasSheetToBeSelected}
          isLoadingDataExcel={props.isLoadingDataExcel}
          setIsOldSheetOrAreaSelected={props.setIsOldSheetOrAreaSelected}
          setIsSheetChartAndAreaToHide={props.setIsSheetChartAndAreaToHide}
          isSheetChartAndAreaToHide={props.isSheetChartAndAreaToHide}
        />
      </div>
    );
  } else {
    return (
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <TextField
          id="cell_edit"
          label={formatMessage(`cof.objectsource.amount.excelpanel.selectcell`)}
          required
          value={props.isLoadingDataExcel ? "" : areaValue}
          placeholder={props.isLoadingDataExcel ? formatMessage("cof.base.loadingdata") : ""}
          onChange={selectAmountFromExcel}
          disabled={
            sheet == null || !isFileExcelExisting || isComponentInstance || isLocked || props.hasSheetToBeSelected
          }
        />
      </div>
    );
  }
};

export default ImportAmountAreaSelectionField;
